export default {
  button: {
    login: "로그인",
    logout: "로그아웃",
    cancel: "취소",
    save: "저장",
    edit: "수정",
    delete: "삭제",
    next: "다음",
    doorlock_uninstall: "삭제",
    battery: "배터리",
    room_add: "객실 생성",
    floor_add: "층 생성",
    building_add: "빌딩 생성",
    staff_add: "스태프 생성",
    key_issue: "키 발급",
    booking_excel_upload: "예약 파일 업로드",
    booking_excel_download: "예약 파일 다운로드",
    booking_add: "예약 생성",
    sms_resend: "SMS 재전송",
    report_excel_download: "리포트 다운로드",
    close: "닫기",
    ok: "확인",
  },
  placeholder: {
    phone_number: "숫자만 입력",
    password: "비밀번호",
    hotel_name: "단지 이름을 입력해주세요.",
    address: "주소를 입력해주세요.",
    description_hotel: "단지에 대한 설명을 입력해주세요.",
    commonroom_name: "공용도어 이름을 입력해주세요.",
    commonroom_select: "공용도어를 선택해주세요.",
    start_at: "시작일자를 선택해주세요.",
    end_at: "종료일자를 선택해주세요.",
    type: "타입",
    type_select: "타입을 선택해주세요.",
    building: "빌딩",
    building_name: "빌딩 이름을 입력해주세요.",
    building_select: "빌딩을 선택해주세요.",
    room_name: "객실 이름을 입력해주세요.",
    room_select: "객실을 선택해주세요.",
    floor_name: "층 이름을 입력해주세요.",
    floor_select: "층을 선택해주세요.",
    rms_id: "RMS ID를 입력해주세요.",
    advertise_strength: "Advertise 신호 세기를 선택해주세요.",
    connected_strength: "Connected 신호 세기를 선택해주세요.",
    staff_name: "스태프 이름을 입력해주세요.",
    role: "권한을 선택해주세요.",
    checkin_at: "입실일자를 선택해주세요.",
    checkout_at: "퇴실일자를 선택해주세요.",
    user_name: "예약자명을 입력해주세요.",
    description_booking: "예약에 대한 설명을 입력해주세요.",
    file_select: "엑셀 파일만 업로드 가능합니다.",
  },
  description: {
    building_count: "건물",
    room_count: "객실",
    app_link: "앱 바로가기",
    no_room_type: "객실타입 없음",
  },
  success_message: {
    edit_hotel: "단지 정보 수정 완료.",
    delete_hotel: "단지 삭제 완료.",
    delete_booking: "예약 삭제 완료.",
    add_booking: "예약 생성 완료.",
    issue_key: "키 발급 완료.",
    delete_key: "키 삭제 완료.",
    add_building: "빌딩 생성 완료.",
    delete_building: "빌딩 삭제 완료.",
    edit_building: "빌딩 정보 수정 완료.",
    add_floor: "층 생성 완료.",
    delete_floor: "층 삭제 완료.",
    edit_floor: "층 정보 수정 완료.",
    add_room: "객실 생성 완료.",
    delete_room: "객실 삭제 완료.",
    edit_room: "객실 정보 수정 완료.",
    uninstall_doorlock: "도어락 삭제 완료.",
    add_staff: "스태프 생성 완료.",
    delete_staff: "스태프 삭제 완료.",
    edit_staff: "스태프 정보 수정 완료.",
    delete_staffkey: "스태프키 삭제 완료.",
    send_sms: "SMS 전송 완료.",
    upload_file: "파일 업로드 성공.",
  },
  error_message: {
    login: "로그인 실패.",
    edit_hotel: "단지 정보 수정 실패.",
    delete_hotel: "단지 삭제 실패.",
    delete_booking: "예약 삭제 실패.",
    add_booking: "예약 생성 실패.",
    missing_parameter: "필수 입력값을 확인해주세요.",
    issue_key: "키 발급 실패.",
    delete_key: "키 삭제 실패.",
    add_building: "빌딩 생성 실패.",
    delete_building: "빌딩 삭제 실패.",
    edit_building: "빌딩 정보 수정 실패.",
    add_floor: "층 생성 실패.",
    delete_floor: "층 삭제 실패.",
    edit_floor: "층 정보 수정 실패.",
    add_room: "객실 생성 실패.",
    delete_room: "객실 삭제 실패.",
    edit_room: "객실 정보 수정 실패.",
    uninstall_doorlock: "도어락 삭제 실패.",
    add_staff: "스태프 생성 실패.",
    delete_staff: "스태프 삭제 실패.",
    edit_staff: "스태프 정보 수정 실패.",
    issue_staffkey: "스태프키 발급 실패.",
    delete_staffkey: "스태프키 삭제 실패.",
    send_sms: "SMS 전송 실패.",
    no_file: "업로드할 엑셀 파일을 선택해주세요.",
    upload_file: "파일 업로드 실패.",
    download_file: "파일 다운로드 실패.",
    no_data: "내용 없음",
  },
  confirm_message: {
    delete_hotel: "선택한 단지를 삭제할까요?",
    delete_booking: "선택한 예약을 삭제할까요?",
    download_booking: "예약 목록을 다운로드 하시겠습니까?",
    delete_key: "선택한 키를 삭제할까요?",
    delete_building: "선택한 빌딩을 삭제할까요?",
    delete_floor: "선택한 층을 삭제할까요?",
    delete_room: "선택한 객실을 삭제할까요?",
    uninstall_doorlock: "선택한 도어락을 삭제할까요?",
    delete_staff: "선택한 스태프를 삭제할까요?",
    delete_staffkey: "선택한 스태프키를 삭제할까요?",
    send_sms: "SMS를 보내시겠습니까?",
  },
  content_title: {
    hotel_list: "단지를 선택해주세요.",
    hotel_detail: "단지 상세정보",
    building_list: "빌딩 목록",
    building_detail: "빌딩 상세정보",
    building_add: "빌딩 생성",
    building_edit: "빌딩 수정",
    floor_list: "층 목록",
    floor_detail: "층 상세정보",
    floor_add: "층 생성",
    floor_edit: "층 수정",
    room_list: "객실 목록",
    room_detail: "객실 상세정보",
    room_add: "객실 생성",
    room_edit: "객실 수정",
    doorlock_list: "도어락 목록",
    doorlock_detail: "도어락 상세정보",
    battery_chart: "배터리 차트",
    staff_list: "스태프 목록",
    staff_detail: "스태프 상세정보",
    staff_add: "스태프 생성",
    staff_edit: "스태프 수정",
    staffkey_issue: "스태프키 발급",
    booking_list: "예약 목록",
    booking_detail: "예약 상세정보",
    booking_add: "예약 생성",
    booking_edit: "예약 수정",
    booking_upload: "예약 파일 업로드",
    key_issue: "키 발급",
    report: "리포트",
    report_detail: "리포트 상세정보",
  },
  sidebar_column: {
    home: "처음으로",
    hotel: "단지 설정",
    building: "빌딩 관리",
    floor: "층 관리",
    room: "객실 관리",
    doorlock: "도어락 관리",
    doorlockTile: "도어락 관리(타일형)",
    booking: "예약 관리",
    staff: "스태프 관리",
    report: "리포트",
  },
  tab_column: {
    building_detail: "빌딩 정보",
    floor_list: "층 목록",
    floor_detail: "층 정보",
    room_list: "객실 목록",
    room_detail: "객실 정보",
    doorlock_detail: "도어락 정보",
    battery_chart: "도어락 배터리",
    doorlock_log: "도어락 로그",
    staff_detail: "스태프 정보",
    staffkey_list: "스태프키 목록",
    booking_detail: "예약 정보",
    userkey_list: "키 목록",
  },
  data_column: {
    hotel_name: "단지 이름",
    timezone: "타임존",
    address: "주소",
    description: "비고",
    pincode_day_type_offset: "일단위 출입번호 입실시간",
    commonroom_name: "공용도어",
    view: "상세보기",
    doorlock_name: "객실",
    type: "타입",
    doorlock_serial: "시리얼번호",
    building: "빌딩",
    building_name: "빌딩",
    floor: "층",
    floor_name: "층",
    status: "상태",
    fw_type: "모델명",
    fw_version: "FW 버전",
    battery_status: "배터리 상태",
    created_at: "생성일",
    updated_at: "수정일",
    log_id: "로그 ID",
    message: "내용",
    evented_at: "이벤트 발생일",
    room: "객실",
    room_name: "객실",
    rms_id: "RMS ID",
    allow_keytag: "키택 사용",
    advertise_strength: "Advertise 신호 세기",
    connected_strength: "Connected 신호 세기",
    room_count: "객실 개수",
    commonroom_count: "공용도어 개수",
    staff: "스태프",
    staff_name: "스태프 이름",
    role: "권한",
    regist_status: "가입 상태",
    phone_number: "전화번호",
    cardkey_count: "카드키 개수",
    mobilekey_count: "모바일키 개수",
    pincode_count: "출입번호 개수",
    issue_type: "발급 방법",
    start_at: "시작일자",
    end_at: "종료일자",
    grantor: "발급자",
    key_type: "키 타입",
    card_no: "카드번호",
    exchangekey: "교환코드",
    pincode: "출입번호",
    sequence: "시퀀스",
    user_name: "예약자명",
    checkin_at: "입실일자",
    checkout_at: "퇴실일자",
    pincode_type: "출입번호 타입",
    key_user_name: "사용자",
    content: "내용",
    checkin_day: "입실일",
    checkin_hour: "입실시간",
    checkout_day: "퇴실일",
    checkout_hour: "퇴실시간",
    facility: "시설",
    actor_name: "사용자",
    actor_phone_number: "전화번호",
    actor_role: "스태프 레벨",
    owner_name: "이름",
    owner_phone_number: "전화번호",
    owner_role: "스태프 레벨",
    content_detail: "상세내용",
    file_select: "파일 선택",
  },
  data: {
    staff_role: {
      master: "마스터",
      manager: "관리 스태프",
      housekeeping: "하우스키핑",
      manager_mobilekey: "스태프 모바일키",
      doorlock_setting: "도어락 세팅",
    },
    doorlock_type: {
      room: "객실",
      commonroom: "공용도어",
      building: "빌딩도어",
      floor: "층도어",
      elevator: "엘리베이터",
      keytag: "키택",
    },
    doorlock_status: {
      created: "미설치",
      installed: "설치",
    },
    allow_keytag: {
      true: "O",
      false: "X",
    },
    regist_status: {
      granting: "가입 대기중",
      granted: "가입 완료됨",
    },
    issue_type: {
      copy: "복사 발급",
      new: "신규 발급",
    },
    key_type: {
      cardkey: "카드키",
      mobilekey: "모바일키",
      pincode: "출입번호",
    },
    pincode_type: {
      day: "일단위",
      hour: "시간단위",
      min: "10분단위",
    },
    report_type: {
      key_issue: "키발급 리포트",
      facility: "시설 정보 리포트",
      staff: "스태프 정보 리포트",
      use_mobilekey: "모바일키 사용 이력 리포트",
    },
    report_key_type: {
      mobilekey: "모바일키",
      pincode: "출입번호",
      cardkey: "카드키",
      cardkey_master: "마스터 카드",
      cardkey_ble: "BLE 카드",
      cardkey_init: "초기화 카드",
    },
    report_content: {
      issue_userkey: "게스트키 발행",
      cancel_userkey: "게스트키 취소",
      create_hotel: "단지 생성",
      update_hotel: "단지 정보 변경",
      delete_hotel: "단지 삭제",
      create_building: "빌딩 생성",
      update_building: "빌딩 정보 변경",
      delete_building: "빌딩 삭제",
      create_room: "객실 생성",
      update_room: "객실 정보 변경",
      delete_room: "객실 삭제",
      create_commonroom: "공용도어 생성",
      update_commonroom: "공용도어 정보 변경",
      delete_commonroom: "공용도어 삭제",
      install_doorlock: "도어락 설치",
      uninstall_doorlock: "도어락 삭제",
      grant_staff: "스태프 추가",
      update_staff: "스태프 정보 변경",
      revoke_staff: "스태프 삭제",
      issue_staffkey: "스태프키 발행",
      cancel_staffkey: "스태프키 취소",
      start_cleaning: "청소시작",
      end_cleaning: "청소완료",
      open_staffmobilekey: "스태프 모바일키로 오픈",
      open_usermobilekey: "게스트 모바일키로 오픈",
    },
  },
  doorlock_detail_modal: {
    room: "객실",
    room_condition: "객실상태",
    check_in_out: "체크인/체크아웃",
    card_key_issuance_information: "카드키 발행정보",
    pin_code_issuance_information: "핀코드 발행정보",
    mobile_key_issuance_information: "모바일키 발행정보",
    lora_network_information: "LoRa모듈 상태정보",
    door_open: "도어 오픈",
    set_door_lock_time: "도어락 시간 설정",
    change_door_lock_sequence_number: "락아웃 (카드키)",
    move_room_card_key: "객실 이동 (카드키)",
    extension_of_check_out_time: "체크아웃 시간 연장",
    change_room_status: "객실 상태 변경",
    move_room_pin_code: "객실 이동 (핀코드)",
    status_logd: "상태 로그",
    control_logd: "제어 로그",
    full_sync: "전체 동기화",
    function: "기능",
    check_out: "체크아웃",
    change_check_out_time: "변경 체크아웃 시간",
    last_update_time: "마지막 업데이트 시간",
    lock_out_pin_code: "락아웃 (핀코드)",
  },
  company_title: "H2O SMW",
};
